import _ from "lodash";

export type Kind = "normal" | "gift";

export const kinds: Kind[] = ["gift", "normal"];

export const selectKinds = kinds.map((kind) => {
  return { value: kind, label: kind.replaceAll("_", " ").toUpperCase() };
});

export const colorsByKind: Record<Kind, string> = {
  normal: "cyan",
  gift: "orange",
};
